export default "__VITE_ASSET__80f9ee98__"